<template>
  <div class="content">
    <div class="row">
      <label class="col-sm-2 col-form-label">프롬프트</label>
      <div class="col-sm-10">
        <base-input placeholder="내용">
          <textarea class="form-control" id="content" rows="10" v-model="text"></textarea>
        </base-input>
      </div>
      <label class="col-sm-2 col-form-label">창의성 제어(0~1)</label>
      <div class="col-sm-10">
        <base-input placeholder="내용" v-model="temperature">
          <span slot="helpBlock" class="form-text" />
        </base-input>
      </div>
      <label class="col-sm-2 col-form-label">모델</label>
      <div class="col-sm-10">
        <base-input placeholder="내용" v-model="model">
          <span slot="helpBlock" class="form-text" />
        </base-input>
      </div>
      <label class="col-sm-2 col-form-label">기사개수</label>
      <div class="col-sm-10">
        <base-input placeholder="내용" v-model="limit">
          <span slot="helpBlock" class="form-text" />
        </base-input>
      </div>
      <div class="col-sm-2">제외 아티스트</div>
      <div class="col-sm-10">
        <base-input placeholder="내용" v-model="unitIds">
          <span slot="helpBlock" class="form-text" />
        </base-input>
      </div>
      <!--      <ArtistSelect-->
      <!--        @unitChangeEvent="getArtistInfo"-->
      <!--        class="col-sm-10"-->
      <!--        :show-title="false"-->
      <!--        :selected-unit-id="unitId"-->
      <!--        :initial-unit-id="0"-->
      <!--        :include-unit-artist="false"-->
      <!--        :show-members="false"-->
      <!--        :is-multiple="true"-->
      <!--      />-->
    </div>
    <div class="row">
      <div class="col-sm-12">
        <base-button @click="setKeyword()" type="success">저장</base-button>
        <base-button @click="sendSlackNotification()" type="success">슬랙전송</base-button>
      </div>
    </div>
  </div>
</template>

<script>
import { BaseInput } from "@/components";
import ArtistSelect from "@/pages/Components/ArtistSelect.vue";

export default {
  name: "Keywords",
  components: { ArtistSelect, BaseInput },
  async created() {
    await this.getKeyword();
  },
  data() {
    return {
      limit: 0,
      text: null,
      temperature: 1,
      model: "gpt-4o-mini",
      unitId: [],
      unitIds: null,
    };
  },
  methods: {
    async getArtistInfo(param) {
      const v = param?.unitId;
      this.unitId = Array.isArray(v) ? v : v != null ? [v] : [];
    },
    async getKeyword() {
      return this.$axios.get(`/common/config?key=KEYWORD`).then((res) => {
        let raw = res.data.data;
        let parsed;

        try {
          raw = typeof raw === "string" ? raw.replace(/\n/g, "\\n") : raw;
          parsed = JSON.parse(raw);

          // 혹시 파싱한 결과가 여전히 string이면 한 번 더 parse
          if (typeof parsed === "string") {
            parsed = JSON.parse(parsed);
          }
        } catch (e) {
          console.error("JSON 파싱 실패:", e);
        }
        this.limit = parsed.limit;
        this.temperature = parsed.temperature;
        this.text = parsed.text;
        this.model = parsed.model;
        this.unitIds = parsed.unitId.toString();
      });
    },
    async setKeyword() {
      const param = {
        limit: this.limit,
        temperature: this.temperature,
        text: this.text.trim().replace(/^"+|"+$/g, ""),
        model: this.model,
        unitId: this.unitIds.split(",").map((unitId) => Number(unitId)),
      };
      const value = JSON.stringify(param).replace(/\n/g, "\\n");
      await this.$axios.put("/common/config", { key: "KEYWORD", value: value });
      Toast.success("설정되었습니다");
      await this.getKeyword();
    },

    async sendSlackNotification() {
      await this.$axios.put("/common/sendKeyword");
    },
  },
};
</script>
<style lang="scss">
.table-view {
  margin-left: 0;
  margin-bottom: 60px;
}
.filter-section {
  margin-bottom: 50px;
}
</style>
